export const inputTextSizeClasses = {
    xs: 'placeholder:text-xs text-xs',
    sm: 'placeholder:text-sm text-sm',
    md: 'placeholder:text-md text-md',
    lg: 'placeholder:text-lg text-lg',
    xl: 'placeholder:text-xl text-xl',
};
